import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Alert from "/src/util/alert";

import EntityDropdown from "../../component/EntityDropdown";
import { LangUpdateContext } from "../../layout/LangContext";
import { MANAGER_PROFILE } from "../../config/lang";

import { call } from "../../util/action";
import { update_me } from "../../util/redux/actions";
import { translate } from "../../util/util";

class Edit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      item: {
        first_name: "",
        last_name: "",
        email: "",
        county: "",
        telegram_id: "",
        position: "",
      },
      imgError: false,
    };
  }
  static contextType = LangUpdateContext;

  componentDidMount() {
    const { item } = this.state;
    const { me } = this.props;
    this.setState({ item: { ...item, ...me } });
  }

  onChange = (property, value) => {
    this.setState(prev => ({ item: { ...prev.item, [property]: value } }));
  };

  translate = name => {
    const lang = this.state.item.language;
    return translate(MANAGER_PROFILE, name, lang);
  };

  submit = () => {
    const { dispatch } = this.props;
    const { item } = this.state;

    // Work on a shallow copy so we never mutate state
    const payload = { ...item };

    // Strip photo — not editable here
    delete payload.photo;

    // Always send county as a plain ID (it may be a full object if unchanged)
    if (payload.county && typeof payload.county === "object") {
      payload.county = payload.county.id || null;
    }
    if (!payload.county) {
      delete payload.county;
    }

    const prevLanguage = this.props.me.language;
    call({ method: "PUT", url: "users/" + payload.id + "/", post: payload }, r => {
      if (r && r.id) {
        dispatch(update_me({ ...this.props.me, ...r }));
        if (r.language !== prevLanguage) {
          Alert.success(this.translate("save_success_reload"), { position: "bottom-right", timeout: 1000 });
          setTimeout(() => window.location.reload(), 250);
        } else {
          Alert.success(this.translate("save_success"), { position: "bottom-right" });
          this.context.updateLangFn();
        }
      } else {
        Alert.warning("Error while saving. " + JSON.stringify(r), { position: "bottom-right" });
      }
    });
  };

  render() {
    const { item, imgError } = this.state;

    const fullName = `${item.first_name || ""} ${item.last_name || ""}`.trim();

    const roleLabel = item.role === "supervisor_manager" ? "Supervisor Manager" : item.role === "supervisor" ? "Supervisor" : item.role || "";

    return (
      <div className="md-profile-page">
        <div className="md-profile-card">
          {/* ── Avatar hero ── */}
          <div className="md-profile-hero">
            <div className="md-profile-avatar">
              {item.photo && !imgError ? (
                <img src={item.photo} alt={fullName} onError={() => this.setState({ imgError: true })} />
              ) : (
                <span className="md-nav-icon md-profile-avatar-icon">person</span>
              )}
            </div>
            <div className="md-profile-fullname">{fullName || "—"}</div>
            {roleLabel && <div className="md-profile-role-badge">{roleLabel}</div>}
          </div>

          {/* ── Form ── */}
          <div className="md-profile-form">
            <div className="md-profile-row">
              <div className="md-profile-field">
                <label className="md-profile-label">{this.translate("name")}</label>
                <input
                  type="text"
                  className="md-profile-input"
                  placeholder={this.translate("name")}
                  value={item.first_name || ""}
                  onChange={e => this.onChange("first_name", e.target.value)}
                />
              </div>
              <div className="md-profile-field">
                <label className="md-profile-label">{this.translate("surname")}</label>
                <input
                  type="text"
                  className="md-profile-input"
                  placeholder={this.translate("surname")}
                  value={item.last_name || ""}
                  onChange={e => this.onChange("last_name", e.target.value)}
                />
              </div>
            </div>

            <div className="md-profile-field">
              <label className="md-profile-label">{this.translate("position")}</label>
              <input
                type="text"
                className="md-profile-input"
                placeholder={this.translate("position")}
                value={item.position || ""}
                onChange={e => this.onChange("position", e.target.value)}
              />
            </div>

            <div className="md-profile-field">
              <label className="md-profile-label">{this.translate("my_region")}</label>
              <EntityDropdown
                entity="county"
                value={item.county && item.county.id ? item.county.id : item.county}
                onChange={e => this.onChange("county", e?.id)}
              />
            </div>

            <div className="md-profile-field">
              <label className="md-profile-label">{this.translate("telegram")}</label>
              <input
                type="text"
                className="md-profile-input"
                placeholder="@username"
                value={item.telegram_id || ""}
                onChange={e => this.onChange("telegram_id", e.target.value)}
              />
            </div>

            <div className="md-profile-field">
              <label className="md-profile-label">{this.translate("language")}</label>
              <EntityDropdown
                entity="language"
                id={item.id ? item.id : null}
                value={item.id && item.language ? item.language : 1}
                onChange={e => this.onChange("language", e?.code)}
              />
            </div>

            <div className="md-profile-actions">
              <button className="btn btn-primary md-profile-save-btn" onClick={() => this.submit()}>
                <span className="md-nav-icon" style={{ fontSize: "20px" }}>
                  save
                </span>
                {this.translate("save")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(state => ({ me: state.me }))(Edit));
